// removed by extract-text-webpack-plugin
module.exports = {"base":"Icon_base--xFfnG","bars":"Icon_bars--r2OiD Icon_base--xFfnG","filter":"Icon_filter--2aKkk Icon_base--xFfnG","info":"Icon_info--2nuUO Icon_base--xFfnG","notification":"Icon_notification--EWRaY Icon_base--xFfnG","player":"Icon_player--2iXIy Icon_base--xFfnG","vehicle":"Icon_vehicle--1LP_D Icon_base--xFfnG","warning":"Icon_warning--3tOQF Icon_base--xFfnG","stats":"Icon_stats--1u7u3 Icon_base--xFfnG"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-wot-bootstrap/lib/components/Icon/Icon.css
// module id = 1761
// module chunks = 16